import {
  AltEmailRegEx,
  PhoneNumberFormat,
} from "@msidentity/SISU/components/inputs/input-regex-constants";
import { MemberNameType } from "@msidentity/SISU/model/user";
import { type UsernameRecoveryCollectProofViewStrings } from "./views/collect-proof/username-recovery-collect-proof-view-types";
import {
  type UsernameRecoveryActions,
  UsernameRecoveryActionType,
} from "./username-recovery-reducer";

/**
 * Valiate Email Input
 * @param args The arguments for this function
 * @param args.dispatchAction funtion to dispatach state action
 * @param args.inputType Alias type EASI or Live
 * @param args.usernameValue name to valiate
 * @param args.strings localized strings to set the error state.
 * @returns boolean
 */
export const validateUsernameInputAndDispatchError = (args: {
  dispatchAction: React.Dispatch<UsernameRecoveryActions>;
  inputType: MemberNameType;
  usernameValue: string;
  strings: UsernameRecoveryCollectProofViewStrings;
}): boolean => {
  const { dispatchAction, inputType, usernameValue, strings } = args;
  if (inputType === MemberNameType.EASI) {
    if (usernameValue.trim() === "") {
      dispatchAction({
        type: UsernameRecoveryActionType.SetError,
        error: strings.phoneOrEmailRequired,
      });
      return false;
    }

    if (!usernameValue.match(AltEmailRegEx)) {
      dispatchAction({
        type: UsernameRecoveryActionType.SetError,
        error: strings.invalidEmailError,
      });
      return false;
    }

    dispatchAction({ type: UsernameRecoveryActionType.SetError, error: "" });
    return true;
  }

  if (inputType === MemberNameType.Phone) {
    if (usernameValue.trim() === "") {
      dispatchAction({
        type: UsernameRecoveryActionType.SetError,
        error: strings.phoneRequired,
      });
      return false;
    }

    if (!usernameValue.match(PhoneNumberFormat)) {
      dispatchAction({
        type: UsernameRecoveryActionType.SetError,
        error: strings.invalidPhoneError,
      });
      return false;
    }

    dispatchAction({ type: UsernameRecoveryActionType.SetError, error: "" });
    return true;
  }

  return false;
};
